import get from 'lodash/get'
import { connect } from 'react-redux'

import { SinglePageNationality } from 'common/widgets/blocks'


export default connect(state => ({
  data: get(state, 'schoolNewServices.data.static_content.nationality_mix', []),
}))(SinglePageNationality)
